import React from "react";
import styled from "styled-components";
import Flag from "react-world-flags";

interface Props {
  countryCode: string;
}

const CountrySelectFlag = ({ countryCode }: Props) => {
  return (
    <FlagContainer>
      <Flag code={countryCode} height="22" />
    </FlagContainer>
  );
};

const FlagContainer = styled.div`
  height: 20px;
  width: 20px;
  border: 1px solid ${({ theme }) => theme.redesign.defaultColor};
  display: flex;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-right: 10px;
`;

export default CountrySelectFlag;
